<div class="cookie-consent-modal-type-header">
  <div class="cookie-consent-modal-type-header-title"
       [attr.labelFor]="type() + '-toggle'">
    {{ title() | translate }}
  </div>
  <app-toggle [id]="type() + '-toggle'"
              [formControl]="control()"/>
</div>
<div class="cookie-consent-modal-type-description"> {{ description() | translate }}</div>
